<ng-container *transloco="let t">
  <div [class]="labelClass()">
    <label [for]="controlId()" class="text-xs font-medium text-ink tracking-tight">
      {{ t(label()) }} @if (!disabled() && required()) {
      <span class="text-danger" aria-hidden="true"> *</span>
      }
    </label>
  </div>
  <textarea
    [id]="controlId()"
    [name]="controlId()"
    [class]="appliedClasses()"
    [placeholder]="t(placeholder())"
    [rows]="rows()"
    [style.resize]="resize()"
    class="form-input juno-textarea"
    [disabled]="disabled()"
    [readonly]="pending()"
    [class.disabled]="disabled()"
    [class.input-error]="showError()"
    #textarea
    [value]="value() ?? ''"
    (input)="value.set(textarea.value)"
    (blur)="touch.emit()"
    [attr.aria-required]="required()"
    [attr.aria-busy]="pending()"
    [attr.aria-invalid]="showError()"
    [attr.aria-describedby]="showError() ? controlId() + '-error' : null"
  ></textarea>
  @if (showError()) {
  <div [id]="controlId() + '-error'" role="alert">
    <juno-libs-ui-error [errors]="errors()"></juno-libs-ui-error>
  </div>
  }
</ng-container>
